import React from "react";
import { Link } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { FaUsers } from "react-icons/fa";
import { generateCategoryDetail } from "helpers";
import { getCategoryVisual } from "helpers/categoryVisual";
import SectionHead from "./SectionHead";
import "./HomeSections.css";

// Boot-time redux'tan gelen level-1 kategoriler için görsel kart ızgarası.
// Hiç network çağrısı yok; CategoryList sidebar'ının ana-ekran vitrin karşılığı.
function CategoryShowcase() {
  const { categories } = useSelector(
    (state) => ({ categories: state.category.categories }),
    shallowEqual
  );

  if (!categories || categories.length === 0) return null;

  return (
    <div className="hs-section container">
      <SectionHead
        title="Kategoriler"
        subtitle="Aradığın kategoriden hızlıca başla"
        accent="#11986e"
      />
      <div className="hs-cat-grid">
        {categories.map((cat) => {
          const { Icon, color, tint, subtitle, image } = getCategoryVisual(cat);
          return (
            <Link
              key={cat._id}
              to={generateCategoryDetail(cat.slug)}
              className="hs-cat"
              style={{ "--cat-color": color, "--cat-tint": tint }}
            >
              <span
                className={`hs-cat__ring${image ? " hs-cat__ring--photo" : ""}`}
              >
                {image ? (
                  <img src={image} alt={cat.name} className="hs-cat__photo" />
                ) : (
                  <Icon size={54} color={color} />
                )}
              </span>
              <span className="hs-cat__name">{cat.name}</span>
              {subtitle ? (
                <span className="hs-cat__sub">{subtitle}</span>
              ) : null}
              {cat.rate ? (
                <span className="hs-cat__count">
                  <FaUsers size={13} />
                  {cat.rate} İlan
                </span>
              ) : null}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default CategoryShowcase;
